module.exports = __webpack_public_path__ + "static/media/resume.7f9fa236.pdf";